import { AppTreeSide, UniDateRangePicker, Bar } from 'components'
import ShowDataNode from '../../common/showDataNode'
import MapNavigator from '../../common/mapNavigator'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import typeImageMixin from '@/mixins/type-image-mixin.js' // 引入mixin文件
import {getRegionList} from '@/api/get-data.js'
import {loadRegionTree} from '@/utils/tree'
// import {getTodayBeginAndEndDate} from '@/utils/date'

let controlNodeImageFileName = require('@/assets/img/device/light.png')

export default {
  name: 'AuxiliaryControl',
  data () {
    return {
      // 侧边栏打开标志
      treeSideBarOpen: true,
      // 底部栏打开标志
      footerOpen: true,
      // 树数据
      treeData: [],
      treeExpandedKeys: [], // 默认展开树节点key
      // 树查询条件
      treeQueryParams: {
        pageNum: 1,
        pageSize: 1000
      },
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      // 树节点显示过滤
      treeNodeFilter: '',
      filteredTreeData: [],
      // 活动页面索引
      activeTabName: '0',
      // 遮罩层
      loading: false,
      // 组态画面页面--------------------------------------------------------------------------------------------------
      // 查询条件
      mapQueryParams: {
        mapId: 0,
        regionId: -1,
        systemKind: this.systemKind
      },
      mapNavigatorHeightExpired: true,
      // 数据列表页面--------------------------------------------------------------------------------------------------
      // 卡片数据
      cardData: [], // 固定为4行4列
      controlNodeImageFileNames: [], // 图片url数组，固定为16个
      inputControlNodeControlStates: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 输入控制状态数组，固定为16个
      cardTotalItem: 0, // 记录总数
      cardMaxRowCount: 4, // 当前页卡片最大行数
      cardMaxColCount: 4, // 当前页卡片最大列数
      cardRowCount: 0, // 当前页卡片实际行数
      cardColCountPerRows: [], // 当前页卡片每行列数
      // 卡片查询条件
      // 控制资源种类
      controlResourceKinds: [
        { id: 24, name: '信号量输出' },
        { id: 25, name: '模拟量输出' }
      ],
      checkedResourceKindIds: [], // 勾选的资源种类集合
      lastDataNodeUpdateDateTime: 0,
      cardQueryParams: {
        regionId: -1,
        nodeId: 0,
        descendantRegionRequired: 1,
        resourceKind: 255,
        controlledObjectKind: 255,
        systemKind: this.systemKind,
        beginUpdateDateTime: 0,
        dataNodeStateRequired: 1, // 要求返回数据节点状态
        encoderStateRequired: 1, // 要求返回监控设备状态
        pageNum: 1,
        pageSize: 16
      },
      pageTotalCount: 0,
      pageOnlineCount: 0,
      pageOfflineCount: 0,
      // 卡片当前项
      cardCurrentItem: null,
      cardCurrentIndex: -1,
      // 控制节点信息弹窗
      showControlNodeModalOpen: false,
      // 轮巡定时器
      pollingTimer: null
    }
  },
  props: {
    systemKind: {
      type: Number,
      default() {
        return 4100 // 辅助控制
      }
    }
  },
  components: {
    AppTreeSide,
    UniDateRangePicker,
    Bar,
    ShowDataNode,
    MapNavigator
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin,
    idNameMixin,
    typeImageMixin
  ],
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  created() {
    // 显示或隐藏树侧边栏
    this.treeSideBarOpen = this.$globalConfig.treeSideBarOpen
    if (this.$route.query.treeSideBarOpen) {
      this.treeSideBarOpen = this.$route.query.treeSideBarOpen === '1' || this.$route.query.treeSideBarOpen === 'true'
    }

    // 根据浏览器宽度设置卡片最大列数
    this.cardMaxColCount = window.outerWidth > 1690 ? 4 : 3
    // 根据卡片最大行数和最大列数返回页数
    this.cardQueryParams.pageSize = this.cardMaxRowCount * this.cardMaxColCount
    // 根据浏览器宽度显示/隐藏底部控制栏
    this.footerOpen = window.outerWidth > 1690

    //
    this.controlNodeImageFileNames = []
    for (let i = 0; i < 16; ++i) {
      this.controlNodeImageFileNames.push(controlNodeImageFileName)
    }
  },
  mounted () {
    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取区域列表
      this.getRegionList2()

      // 开始数据轮巡
      this.startDataPolling()
    })
  },
  beforeDestroy() {
    // 停止数据轮巡
    this.stopDataPolling()
  },
  methods: {
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    toggleFooter() {
      this.footerOpen = !this.footerOpen
    },
    // 查询区域列表
    getRegionList2() {
      this.loading = true
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.loading = false
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData)
        this.$nextTick(() => {
          if (this.treeData.length) {
            // 默认展开根节点
            this.treeExpandedKeys = [this.treeData[0].key]
            // 设置根节点或根节点的首个子节点为当前节点
            let currentKey = null
            if (this.$globalConfig.currentRegionSynchEnabled && this.$store.getters.appCurrentRegionKey) { // 区域同步选择启用
              currentKey = this.$store.getters.appCurrentRegionKey
            } else {
              if (this.$globalConfig.defaultCurrentTreeNode === 0) { // 根节点
                currentKey = this.treeData[0].key
              } else if (this.$globalConfig.defaultCurrentTreeNode === 1) { // 根节点的首个子节点
                currentKey = this.treeData[0].children.length > 0 ? this.treeData[0].children[0].key : this.treeData[0].key
              }
            }
            if (currentKey) {
              this.$refs.tree.setCurrentKey(currentKey)
              // 单击当前节点
              this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
            }
            // 只有一个树节点自动隐藏侧边栏
            if (this.treeData[0].children.length === 0) {
              this.treeSideBarOpen = false
            }
          }
        })
      })
    },
    // 查询控制节点列表
    getControlNodeList() {
      this.loading = true
      this.lastDataNodeUpdateDateTime = 0
      if (this.checkedResourceKindIds.length === 0 || this.checkedResourceKindIds.length === 2) { // 全部控制资源种类
        this.cardQueryParams.resourceKind = 255
      } else { // 单项控制资源种类
        this.cardQueryParams.resourceKind = this.checkedResourceKindIds[0]
      }
      this.cardQueryParams.beginUpdateDateTime = 0 // 忽略开始更新日期时间
      this.$http(this.$api.controlNodeList, this.cardQueryParams).then(
        res => {
          if (res.code === 200) {
            let itemIndex = 0
            res.data.forEach(item => {
              if (item.dataNodeGuagedValue != null) { // 根据关联的数据节点采集值设置控制数值
                item.controlValue = item.dataNodeGuagedValue
              }
              if (item.resourceKind === 24) { // 信号量输出
                item.controlState = this.$type.getResourceControlState(item.resourceKind, item.controlValue, item.valueType) // 根据控制数值返回控制状态
                this.inputControlNodeControlStates[itemIndex] = item.controlState
              } else if (item.resourceKind === 25) { // 模拟量输出
                this.inputControlNodeControlStates[itemIndex] = item.controlValue
              }
              // 根据资源种类和子类型返回图片文件
              this.controlNodeImageFileNames[itemIndex++] = this.deviceImageFileNameByResourceKindAndSubType(item.resourceKind, item.controlledObjectKind)
              // 更新数据节点最后更新日期时间
              if (item.updateDateTime > this.lastDataNodeUpdateDateTime) {
                this.lastDataNodeUpdateDateTime = item.updateDateTime
              }
              if (item.dataNodeUpdateDateTime > this.lastDataNodeUpdateDateTime) {
                this.lastDataNodeUpdateDateTime = item.dataNodeUpdateDateTime
              }
            })

            this.cardData = res.data
            this.cardTotalItem = res.page.totalRow
            // 计算卡片行数
            this.cardRowCount = Math.ceil(this.cardData.length / this.cardMaxColCount) // 向上取整
            // 计算卡片每行列数
            this.cardColCountPerRows = []
            for (let i = 0; i < this.cardRowCount; ++i) {
              this.cardColCountPerRows[i] = (this.cardData.length - this.cardMaxColCount * i) / this.cardMaxColCount >= 1 ? this.cardMaxColCount : (this.cardData.length - this.cardMaxColCount * i) % this.cardMaxColCount
              this.cardColCountPerRows[i] = Math.abs(this.cardColCountPerRows[i]) // 余数可能为负，需取绝对值
            }
            if (res.data.length) {
              if (this.cardCurrentItem === null) {
                this.cardCurrentItem = res.data[0] // 选中首项
                this.cardCurrentIndex = 0
              } else {
                this.cardCurrentItem = this.getRecordById(this.cardCurrentItem.id, res.data)
                if (this.cardCurrentItem === null) { // 数组是否包含选中项
                  this.cardCurrentItem = res.data[0] // 选中首项
                  this.cardCurrentIndex = 0
                }
              }
            }
            // 统计当前页面节点数量
            this.statPageControlNodeCount()
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 查询更新的控制节点列表
    getUpdatedControlNodeList() {
      this.loading = true
      if (this.checkedResourceKindIds.length === 0 || this.checkedResourceKindIds.length === 2) { // 全部控制资源种类
        this.cardQueryParams.resourceKind = 255
      } else { // 单项控制资源种类
        this.cardQueryParams.resourceKind = this.checkedResourceKindIds[0]
      }
      this.cardQueryParams.beginUpdateDateTime = this.lastDataNodeUpdateDateTime + 1 // 设置开始更新日期时间
      this.$http(this.$api.controlNodeList, this.cardQueryParams).then(
        res => {
          if (res.code === 200 && res.data.length > 0) {
            res.data.forEach(item => {
              // let cardItem = this.getRecordById(item.id, this.cardData)
              let cardItemIndex = this.getIndexById(item.id, this.cardData)
              if (cardItemIndex >= 0) {
                if (item.dataNodeGuagedValue != null) { // 根据关联的数据节点采集值设置控制数值
                  item.controlValue = item.dataNodeGuagedValue
                }
                if (item.resourceKind === 24) { // 信号量输出
                  item.controlState = this.$type.getResourceControlState(item.resourceKind, item.controlValue, item.valueType) // 根据控制数值返回控制状态
                  this.inputControlNodeControlStates[cardItemIndex] = item.controlState
                } else if (item.resourceKind === 25) { // 模拟量输出
                }
                this.$set(this.cardData, cardItemIndex, item) // 强制刷新数组元素

                // 更新数据节点最后更新日期时间
                if (item.updateDateTime > this.lastDataNodeUpdateDateTime) {
                  this.lastDataNodeUpdateDateTime = item.updateDateTime
                }
                if (item.dataNodeUpdateDateTime > this.lastDataNodeUpdateDateTime) {
                  this.lastDataNodeUpdateDateTime = item.dataNodeUpdateDateTime
                }
              }
            })

            // 统计当前页面节点数量
            this.statPageControlNodeCount()
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 统计当前页面节点数量
    statPageControlNodeCount() {
      this.pageTotalCount = 0
      this.pageOnlineCount = 0
      this.pageOfflineCount = 0
      if (this.cardTotalItem === 0) {
        return
      }

      this.cardData.forEach(item => {
        ++this.pageTotalCount
        if (this.$type.getResourceOnlineState(item.resourceKind, item.dataNodeAlarmState, item.dataNodeEventTypeSet, item.encoderAlarmState, item.encoderEventTypeSet) === 1) {
          ++this.pageOnlineCount
        } else {
          ++this.pageOfflineCount
        }
      })
    },
    // 开始数据轮巡
    startDataPolling() {
      this.pollingTimer = setInterval(() => {
        if (this.loading) { // 检测上一次查询是否尚未结束
          return
        }
        if (this.activeTabName === '0') {
          if (this.showControlNodeModalOpen) { // 暂停刷新数据
            return
          }
          this.cardData.length ? this.getUpdatedControlNodeList() : this.getControlNodeList()
        } else if (this.activeTabName === '2') {
        } else if (this.activeTabName === '3') {
        }
      }, this.$globalConfig.pagePollingInterval)
    },
    // 停止数据轮巡
    stopDataPolling() {
      if (this.pollingTimer != null) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick(obj) {
      if (this.activeTabName === '0') {
        if (this.cardQueryParams.regionId !== obj.id) {
          this.cardQueryParams.regionId = obj.id
          this.cardQueryParams.pageNum = 1
          this.getControlNodeList()
        }
      } else if (this.activeTabName === '1') {
        if (this.mapQueryParams.regionId !== obj.id) {
          this.mapQueryParams.regionId = obj.id
          if (this.mapNavigatorHeightExpired) {
            setTimeout(() => { // 由于切换页面后monitoringContent高度可能会发生变化，必须等待appTreeSide高度调整完毕才能同步高度
              if (this.$refs.mapNavigator.$el.clientHeight < this.$refs.monitoringContent.clientHeight - 70) { // 设置地图浏览器高度
                let contentHeight = this.$refs.monitoringContent.clientHeight - 70
                this.$refs.mapNavigator.$el.style.height = contentHeight + 'px'
              }
              this.$refs.mapNavigator.switchMap(this.mapQueryParams.mapId, this.mapQueryParams.regionId, this.mapQueryParams.systemKind)
              this.mapNavigatorHeightExpired = false
            }, 500)
          } else {
            this.$nextTick(() => {
              this.$refs.mapNavigator.switchMap(this.mapQueryParams.mapId, this.mapQueryParams.regionId, this.mapQueryParams.systemKind)
            })
          }
        }
      } else if (this.activeTabName === '2') {

      } else if (this.activeTabName === '3') {
      }

      if (this.$globalConfig.currentRegionSynchEnabled) { // 当前区域同步启用
        this.$store.commit('app/SET_CURRENT_REGION_KEY', obj.key) // 更新当前区域key
      }
    },
    // tab页面切换
    handleTabClick(tab) {
      if (this.activeTabName === '1') { // 组态画面
        this.mapNavigatorHeightExpired = true // 切换页面后monitoringContent高度可能会发生变化
      }

      let currentNode = this.$refs.tree.getCurrentNode()
      if (currentNode) {
        this.handleTreeNodeClick(currentNode)
      }
    },
    // 数据列表页面------------------------------------------------------------------------------------------------
    // 查询按钮操作
    handleFormQuery() {
      this.cardQueryParams.page = 1
      this.getControlNodeList()
    },
    // 重置按钮操作
    resetQueryForm() {
      this.cardQueryParams.regionId = 0
      this.cardQueryParams.nodeId = 0
      this.cardQueryParams.descendantRegionRequired = 1
      this.cardQueryParams.resourceKind = 255
      this.cardQueryParams.controlledObjectKind = 255
      this.cardQueryParams.encoderStateRequired = 1
      this.cardQueryParams.pageNum = 1
      this.$refs['queryForm'].resetFields()
      this.handleFormQuery()
    },
    // 分页
    handleCurrentPageChange(val) {
      this.cardQueryParams.pageNum = val
      this.getControlNodeList()
    },
    // 页面条数改变
    handlePageSizeChange(val) {
      this.cardQueryParams.pageSize = val
      this.getControlNodeList()
    },
    // 表格当前记录改变
    handleTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }
      this.cardCurrentItem = currentRow
      this.cardCurrentIndex = this.cardData.indexOf(currentRow)
    },
    // 查看控制节点信息
    handleControlNodeView(item) {
      if (item) {
        this.cardCurrentItem = item // 选中当前项
        this.cardCurrentIndex = this.cardData.indexOf(item)
        this.showControlNodeModalOpen = true
      }
    },
    // 控制节点信息取消提交
    handleShowControlNodeModalCancel() {
      this.showControlNodeModalOpen = false
    },
    // 处理控制状态改变
    handleControlStateChange() {
      if (this.cardCurrentItem == null) {
        this.$messagebox.confirm('请先选中一条记录！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
        return
      }

      let queryText = this.cardCurrentItem.controlState === 0 ? '您确定打开【' : '您确定关闭【'
      queryText += this.cardCurrentItem.name
      queryText += '】吗?'
      this.$messagebox.confirm(queryText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let controlParams = {
          nodeId: this.cardCurrentItem.id,
          controlCmd: this.cardCurrentItem.controlState === 0 ? 0 : 1 // 控制命令，0-打开，1-关闭，2-禁止关(常开)，3-禁止开(常闭)，4-恢复普通模式(允许开关)
        }
        this.$http(this.$api.doControl, controlParams).then(
          res => {
            if (res.code === 200) {
              this.cardCurrentItem.controlValue = this.cardCurrentItem.controlValue === 0 ? 1 : 0
              this.cardCurrentItem.controlState = this.$type.getResourceControlState(this.cardCurrentItem.resourceKind, this.cardCurrentItem.controlValue, this.cardCurrentItem.valueType) // 根据控制数值返回控制状态
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            } else {
              // this.inputControlNodeControlStates[index] = this.cardCurrentItem.controlState // 直接修改数组元素无法立即更新
              this.$set(this.inputControlNodeControlStates, this.cardCurrentIndex, this.cardCurrentItem.controlState) // 恢复控制前状态
            }
          }
        )
      }).catch(() => {
        // this.inputControlNodeControlStates[index] = this.cardCurrentItem.controlState // 直接修改数组元素无法立即更新
        this.$set(this.inputControlNodeControlStates, this.cardCurrentIndex, this.cardCurrentItem.controlState) // 恢复控制前状态
      })
    },
    // 处理调整数值点击
    handleAdjustValue() {
      if (this.cardCurrentItem == null) {
        this.$messagebox.confirm('请先选中一条记录！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
        return
      }

      // 返回当前卡片输入数值
      let newValue = this.inputControlNodeControlStates[this.cardCurrentIndex]
      let queryText = '您确定调整【'
      queryText += this.cardCurrentItem.name
      queryText += '】数值吗?'
      this.$messagebox.confirm(queryText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let controlParams = {
          nodeId: this.cardCurrentItem.id,
          value: newValue
        }
        this.$http(this.$api.aoControl, controlParams).then(
          res => {
            if (res.code === 200) {
              this.cardCurrentItem.controlValue = newValue
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
          }
        )
      }).catch(() => {
      })
    },
    // 全打开
    handleOpenAll() {
      this.$messagebox.confirm('您确定打开当前页面全部节点吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let nodeIds = []
        this.cardData.forEach(item => {
          if (item.resourceKind === 24 && item.controlState === 0) { // 信号量输出
            nodeIds.push(item.id)
          }
        })
        let controlParams = {
          nodeIds: nodeIds,
          controlCmd: 0 // 控制命令，0-打开，1-关闭，2-禁止关(常开)，3-禁止开(常闭)，4-恢复普通模式(允许开关)
        }
        this.$http(this.$api.doControl, controlParams).then(
          res => {
            if (res.code === 200) {
              this.cardData.forEach(item => {
                if (item.resourceKind === 24 && item.controlState === 0) { // 信号量输出
                  item.controlValue = item.controlValue === 0 ? 1 : 0
                  item.controlState = 1
                }
              })
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
          }
        )
      })
    },
    // 全关闭
    handleCloseAll() {
      this.$messagebox.confirm('您确定关闭当前页面全部节点吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let nodeIds = []
        this.cardData.forEach(item => {
          if (item.resourceKind === 24 && item.controlState === 1) { // 信号量输出
            nodeIds.push(item.id)
          }
        })
        let controlParams = {
          nodeIds: nodeIds,
          controlCmd: 1 // 控制命令，0-打开，1-关闭，2-禁止关(常开)，3-禁止开(常闭)，4-恢复普通模式(允许开关)
        }
        this.$http(this.$api.doControl, controlParams).then(
          res => {
            if (res.code === 200) {
              this.cardData.forEach(item => {
                if (item.resourceKind === 24 && item.controlState === 1) { // 信号量输出
                  item.controlValue = item.controlValue === 0 ? 1 : 0
                  item.controlState = 0
                }
              })
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
          }
        )
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/monitoring/auxiliaryControl/AuxiliaryControl.js